import "core-js/modules/es.array.includes.js";
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  class: "mg-menu-bar-link-wrapper"
};
const _hoisted_2 = {
  class: "menu-bar-link-prefix"
};
const _hoisted_3 = {
  class: "menu-bar-link-content"
};
const _hoisted_4 = {
  class: "mg-menu-bar-link-suffix"
};
const _hoisted_5 = {
  class: "mg-menu-bar-children-wrapper"
};
const _hoisted_6 = {
  class: "mg-menu-bar-children-links"
};
import { computed, ref } from 'vue';
import { MgMenu } from '../menu-v2';
export default {
  __name: 'mg-menu-bar-item',
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    shortcut: {
      type: String,
      default: ''
    },
    children: {
      type: Array,
      default: () => []
    },
    isActive: {
      type: Boolean,
      default: false
    },
    trigger: {
      type: String,
      default: 'click',
      validator: val => ['', 'hover', 'click'].includes(val)
    },
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['hover', 'item-hover', 'click', 'item-click'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const props = __props;
    const isHover = ref(false);
    const hasChildren = computed(() => {
      return !!props.children && Array.isArray(props.children) && props.children.length > 0;
    });
    const handleMouseenter = e => {
      isHover.value = true;
      emit('hover', {
        isHover: true,
        $event: e
      });
    };
    const handleMouseleave = e => {
      isHover.value = false;
      emit('hover', {
        isHover: false,
        $event: e
      });
    };
    const handleItemHover = ({
      item,
      isHover,
      $event
    }) => {
      emit('item-hover', {
        item,
        isHover,
        $event
      });
    };
    const handleItemClick = ({
      item,
      $event
    }) => {
      emit('item-click', {
        item,
        $event
      });
    };
    const handleClick = e => {
      emit('click', e);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("li", {
        class: _normalizeClass(['mg-menu-bar-item-wrapper', {
          'is--disabled': __props.disabled
        }, {
          'is--active': __props.isActive
        }, {
          'is--hover': isHover.value
        }]),
        onMouseenter: _withModifiers(handleMouseenter, ["stop"]),
        onMouseleave: _withModifiers(handleMouseleave, ["stop"]),
        onClick: handleClick
      }, [_createElementVNode("a", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_renderSlot(_ctx.$slots, "icon", {}, () => [!!__props.icon ? (_openBlock(), _createElementBlock("i", {
        key: 0,
        class: _normalizeClass(__props.icon)
      }, null, 2)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_3, [_renderSlot(_ctx.$slots, "default", {}, () => [_createTextVNode(_toDisplayString(__props.title), 1)])]), _createElementVNode("div", _hoisted_4, [!!__props.shortcut ? _renderSlot(_ctx.$slots, "shortcut", {
        key: 0
      }, () => [_createElementVNode("span", null, _toDisplayString(__props.shortcut), 1)]) : _createCommentVNode("", true), _createElementVNode("i", {
        class: _normalizeClass(['mg-menu-link-icon', {
          'vxe-icon-check': !hasChildren.value && __props.checked
        }])
      }, null, 2)])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_unref(MgMenu), {
        items: __props.children,
        "is-active": __props.isActive,
        onItemClick: handleItemClick,
        onItemHover: handleItemHover
      }, null, 8, ["items", "is-active"])])])], 34);
    };
  }
};